module.exports = __webpack_public_path__ + "img/adressImg.fb44372c.png";